import { render } from "./StatisticPanel.vue?vue&type=template&id=376d2ede"
import script from "./StatisticPanel.vue?vue&type=script&lang=js"
export * from "./StatisticPanel.vue?vue&type=script&lang=js"

import "./StatisticPanel.vue?vue&type=style&index=0&id=376d2ede&lang=css"

import exportComponent from "/Users/tasselchof/CodeProjects/oarus/oarus-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../../../../../../../oarus-app/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QBtn,QTable});
